module.exports = __webpack_public_path__ + "static/img/07009C_2_3_R_20200712_LC.4245130.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/07009C_2_3_R_20200712_LC.png
// module id = 636W
// module chunks = 0